export const FORM_VALIDATION_SUMMARY_TITLE = 'Unable to Continue';

export const FORM_VALIDATION_SUMMARY_FOOTER =
  'These fields are highlighted in red on the page. Please complete all required fields and try again.';

/** Intro line above the field list; self-contained when no field can be listed. */
export const getFormValidationSummaryDescription = (
  fieldCount: number,
): string =>
  fieldCount === 0
    ? 'Please complete all required fields before you can proceed.'
    : 'The following required field(s) must be completed before you can proceed:';
